<div class="game-tournament-container">
    <div class="tournamentContainer" fxLayout="row" fxLayoutAlign="center center">
        <h2 fxLayoutAlign="center center" class="tournament-title" i18n><img class="tournament-icon" src="assets/icons/selected-deals.svg">Selected Deals</h2>
        <span class="spacer"></span>
        <a class="button-all-games" mat-button color="primary" [routerLink]="[promotionsTrx]" i18n>See All</a>
        <div class="swiper-navigation">
            <img src="assets/playbison/icon-arrow-right.svg" icon-btn direction="left" (click)="prev()">
            <img src="assets/playbison/icon-arrow-right.svg" icon-btn class="button-next" (click)="next()">
        </div>

    </div>
    <div class="card-wrapper">
        <swiper fxFlex="auto" [config]="config" #swiper>
            <ng-template swiperSlide *ngFor="let item of promotionsData; let index=index">
                <app-promotions-home-page-slider [promo]="item"></app-promotions-home-page-slider>
            </ng-template>
        </swiper>
    </div>
</div>